/**
 * 导航栏
 */

import React, { Component } from 'react';
import { Flex, Toast } from 'antd-mobile';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import Util from 'utils';
import Config from 'config/Config';

import { ImgWrap } from 'pubBiz';

require('./AccoumulateLess.less');

const CDN_BASE = Config.CDN_BASE || '';
const TypeList = [
  {
    code: -1,
    name: '优惠顾客'
  },
  {
    code: 0,
    name: '普卡'
  },
  {
    code: 1,
    name: '银卡'
  },
  {
    code: 2,
    name: '金卡'
  },
  {
    code: 3,
    name: '钻卡'
  },
  {
    code: 10,
    name: 'VIP'
  }
];

@inject('AccoumulateMod')
@observer
class AccoumulateView extends Component {
  constructor(props, context) {
    super(props, context);
    this.stores = this.props.AccoumulateMod;
    this.state = {};
  }

  componentDidMount() {
    this.getAccoumulate();
  }

  /**
   * 返回上一页函数
   */
  _onLeftClick = () => {
    window.app.router.goBack();
  };

  /**
   * 展示获取累计制弹框
   */
  getAccoumulate = () => {
    const member_userInfo = Util.getLocalCache(Config.localStorageKeys.member_userInfo) || {};
    const { remindTag = 0, cardTypeId } = member_userInfo || {};
    remindTag && this.stores.getCardTypeDetail(cardTypeId);
  };

  showAccoumulateMoal = () => {
    const member_userInfo = Util.getLocalCache(Config.localStorageKeys.member_userInfo) || {};
    const { showInfo } = this.stores;
    const { bizCardTypeRespDto: data } = toJS(showInfo) || {};
    // accumulateIsSupplement 是否需要完善资料 1-是 0-否
    // accumulateIsOpenCard  是否是开卡 1-是 0-否
    const {
      realName = '',
      phone,
      cardType,
      userType,
      accumulateIsSupplement,
      accumulateIsOpenCard,
      identityCard,
      serviceContact
    } = member_userInfo || {}; // cardType 0普，1银，2金，3钻, -1 优惠
    const { minAmount, type, name: cardTypeName = '' } = data || {};
    const typeObject = TypeList.filter((res) => {
      return +res.code === +type;
    });
    return (
      <Flex
        className="accoumulate-back-mask"
        justify="center"
        justifyContent="center"
        alignItems="center">
        <Flex justify="center" align="center" direction="column" className="accoumulate-back-view">
          <ImgWrap src={`${CDN_BASE}/assets/imgs/bg/popup.png`} mode="full" w="100%" h="100%" />
          <Flex direction="column" className="text-info">
            <Flex justify="start" className="top-title">
              {`${'亲爱的'}${realName ? realName : Util.encryptStr(phone || '顾客')}：`}
            </Flex>
            <span className="inner-text">
              &emsp;&emsp;{`${'祝贺您成功订购优质的健康产品'}，${'您的消费金额已达到'} `}
              <span className="number-price">{minAmount}</span>
              {`，${'恭喜您荣升成为'}${cardTypeName || ''}${'会员'}，${'如有疑问'}，${'可联系您的健康顾问'} `}
              {!!serviceContact && `${'或致电您专属的服务热线'} `}
              {!!serviceContact && <span className="number-price">{serviceContact}</span>}
              {!!serviceContact && `转1`}
              {`，${'我们将秉持“自尊敬人，惠人达己“的核心价值观竭诚为您服务'}！`}
            </span>
          </Flex>
          {!!accumulateIsSupplement && !identityCard
            ? this.bothShow(member_userInfo)
            : this.singleShow()}
          <Flex
            onClick={() => {
              this.checkSupplementInfo(accumulateIsOpenCard ? 2 : 'upgrate');
            }}>
            <ImgWrap
              src={`${CDN_BASE}/assets/imgs/common/close.png`}
              mode="full"
              w="60px"
              h="60px"
            />
          </Flex>
        </Flex>
      </Flex>
    );
  };

  singleShow = () => {
    return (
      <Flex
        className="one-btn"
        align="center"
        justify="center"
        onClick={() => {
          this.checkSupplementInfo('upgrate');
        }}>
        <Flex className="one-btn-text" align="center" justify="center">
          {`${'我知道了'}`}
        </Flex>
      </Flex>
    );
  };

  // 根据不同 的情况展示不同的按钮
  bothShow = (member_userInfo) => {
    return (
      <Flex justify="center" alignItems="center" className="multy-btn">
        <Flex
          className="left-btn"
          justify="center"
          align="center"
          justifyContent="center"
          onClick={() => {
            this.checkSupplementInfo(member_userInfo.accumulateIsOpenCard ? 2 : 'upgrate');
          }}>
          {`${'暂不使用'}`}
        </Flex>
        <Flex
          className="right-btn"
          justify="center"
          align="center"
          onClick={() => {
            this.checkSupplementInfo(member_userInfo);
          }}>
          {`${'获取权益'}`}
        </Flex>
      </Flex>
    );
  };

  // 完善资料处理
  checkSupplementInfo = (value) => {
    //preferentialCustomersTag 是否从优惠顾客上来的，0-不是  1-是
    const { userType, cardTypeId, cardType, cardCode, preferentialCustomersTag } = value || {};
    console.log(value, 'valuevaluevaluevaluevaluevalue');
    if (+value === 2 || value == 'upgrate') {
      this.stores.submitTapUpdate(value === 2 ? 2 : 0).then((res) => {
        if (res && +res.resultCode === 0) {
          value === 2 && this.props.callback && this.props.callback(true, res.data);
          if (value == 'upgrate') {
            this.props.callback && this.props.callback(false);
            Toast.info(`${'升级成功'}！`);
          }
        }
      });
      return;
    }
    if (!preferentialCustomersTag) {
      this.props.callback && this.props.callback(false);
      window.app.routerGoTo({
        pathname: '/register/memCardMsg',
        clear: true,
        state: {
          applyType: '3',
          accumulate: 1,
          supplementInfo: true
        }
      });
    } else if (preferentialCustomersTag) {
      this.props.callback && this.props.callback(false);
      const pathname = '/personal/msgAdd';
      window.app.routerGoTo({
        pathname,
        clear: true,
        state: {
          applyType: 3,
          data: {
            localCardCode: cardCode,
            accumulate: 1,
            remindTag: 1
          }
        }
      });
    } else {
    }
  };

  render() {
    return <React.Fragment>{this.showAccoumulateMoal()}</React.Fragment>;
  }
}

export default AccoumulateView;



// WEBPACK FOOTER //
// ./src/widget/Accoumulate/AccoumulateView.js